import AuthReducer from './AuthReducer';
import UsersReducer from './UsersReducer';
import ShoutoutsReducer from './ShoutoutsReducer';
import TagsReducer from './TagsReducer';
import PersonalizationReducer from './PersonalizationReducer';
import TVModeReducer from './TVModeReducer';
import AchievementsReducer from './AchievementsReducer';
import ProfileReducer from './ProfileReducer';
import CommentsReducer from './CommentsReducer';
import MetricsReducer from './MetricsReducer';
import HotkeyReducer from './HotkeyReducer';
import ToastReducer from './ToastReducer';
import AdminReducer from './AdminReducer';

export default {
  adminStore: AdminReducer,
  authStore: AuthReducer,
  usersStore: UsersReducer,
  shoutoutsStore: ShoutoutsReducer,
  personalizationStore: PersonalizationReducer,
  tvModeStore: TVModeReducer,
  tagsStore: TagsReducer,
  achievementsStore: AchievementsReducer,
  profile: ProfileReducer,
  commentsStore: CommentsReducer,
  metricsStore: MetricsReducer,
  hotkeyStore: HotkeyReducer,
  toastStore: ToastReducer
};



// WEBPACK FOOTER //
// ./src/reducers/index.js